import type { JobStatus } from "@/common/model";
import { createStatusBadge, type TagStatus } from "../status-pill";

// ── Status badges ────────────────────────────────────────────────────────────

export const JobStatusColorMap: Record<JobStatus, TagStatus> = {
	ACTIVE: "success",
	PAUSED: "warning",
};

export const JobStatusLabelMap: Record<JobStatus, string> = {
	ACTIVE: "Active",
	PAUSED: "Paused",
};

export const JobStatusBadge = createStatusBadge(
	JobStatusColorMap,
	JobStatusLabelMap,
);
